export const secondsToHms = (sec) => {
  const n = Number(sec);

  return [n / 3600, (n % 3600) / 60, (n % 3600) % 60]
    .map((v) => (v < 10 ? '0' + parseInt(String(v)) : parseInt(String(v))))
    .filter((i, j) => i !== '00' || j > 0)
    .join(':');
};
